import { render, staticRenderFns } from "./repairItem.vue?vue&type=template&id=84447144&scoped=true"
import script from "./repairItem.vue?vue&type=script&lang=js"
export * from "./repairItem.vue?vue&type=script&lang=js"
import style0 from "./repairItem.vue?vue&type=style&index=0&id=84447144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84447144",
  null
  
)

export default component.exports